/** Used as an action type when starting the message sagas */
export const MESSAGE = 'MESSAGE'

/** Used as an action type when adding a message */
export const ADD_MESSAGE = 'ADD_MESSAGE'

/** Used as an action type when clearing a message */
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'



// WEBPACK FOOTER //
// ./src/actions/messageActionTypes.js